import Resource from './Resource';

class OnboardingImport extends Resource {
	constructor() {
		super('onboardingimports');
	}
}

const resource = new OnboardingImport();
export default resource;
